const status = {
  // 1xx Informativa
  100: 'Continuar',
  101: 'Mudando protocolos',
  102: 'Processamento (WebDAV) (RFC 2518)',
  122: 'Pedido-URI muito longo',
  // 2xx Sucesso
  200: 'OK',
  201: 'Criado',
  202: 'Aceito',
  203: 'Não-autorizado (desde HTTP/1.1)',
  204: 'Nenhum conteúdo',
  205: 'Reset',
  206: 'Conteúdo parcial',
  207: 'Status Multi (WebDAV) (RFC 4918)',
  // 3xx Redirecionamento
  300: 'Múltipla escolha',
  301: 'Movido',
  302: 'Encontrado',
  304: 'Não modificado',
  305: 'Use Proxy (desde HTTP/1.1)',
  306: 'Proxy Switch',
  307: 'Redirecionamento temporário (desde HTTP/1.1)',
  // 4xx Erro de cliente
  400: 'Atenção!',
  401: 'Não autorizado',
  402: 'Pagamento necessário',
  403: 'Proibido',
  404: 'Não encontrado',
  405: 'Método não permitido',
  406: 'Não Aceitável',
  407: 'Autenticação de proxy necessária',
  408: 'Tempo de requisição esgotou (Timeout)',
  409: 'Conflito',
  410: 'Gone',
  411: 'Comprimento necessário',
  412: 'Pré-condição falhou',
  413: 'Entidade de solicitação muito grande',
  414: 'Pedido-URI Too Long',
  415: 'Tipo de mídia não suportado',
  416: 'Solicitada de Faixa Não Satisfatória',
  417: 'Falha na expectativa',
  418: 'Eu sou um bule de chá',
  422: 'Entidade improcessável (WebDAV) (RFC 4918)',
  423: 'Fechado (WebDAV) (RFC 4918)',
  424: 'Falha de Dependência (WebDAV) (RFC 4918)',
  425: 'Coleção não ordenada (RFC 3648)',
  426: 'Upgrade Obrigatório (RFC 2817)',
  450: 'Bloqueados pelo Controle de Pais do Windows',
  499: 'Cliente fechou Pedido (utilizado em ERPs/VPSA)',
  // 5xx outros erros
  500: 'Erro interno do servidor (Internal Server Error)',
  501: 'Não implementado (Not implemented)',
  502: 'Bad Gateway',
  503: 'Serviço indisponível (Service Unavailable)',
  504: 'Gateway Time-Out',
  505: 'HTTP Version not supported'
}

export default status



// WEBPACK FOOTER //
// ./src/services/status.js